import { Component, ViewEncapsulation } from '@angular/core';
import { ResortComponent } from '../shared/resort.component';
import { MatDialogRef } from '@angular/material';
import * as moment from 'moment';

@Component({
    selector: 'terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TermsComponent extends ResortComponent
{

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/terms.component.ts